import useSWR from 'swr';
import { apiBaseURL } from '../../Utils/ProjectConstants';
import { checkRoles } from '../../Utils/helper';
export default function useGetSupervisorsStudents(userId) {

    const { data: usersStudentsData, error, mutate } = useSWR( checkRoles(2) ? `${apiBaseURL}/api/users/students?SupervisorId=${userId}` : null, {
        onSuccess: (data) => console.log('Supervisors students fetched successfully:', data?.data),
        revalidateOnFocus: false,
        dedupingInterval: 300000,
    });
    const isLoading = !usersStudentsData && !error && checkRoles(2)
    
    return {
        usersStudentsData,
        isLoading,
        error,
        mutate,
    }
}